export default __webpack_public_path__ + "static/PAPC-414-13105d3287ee4a32d94faa4a3c488178.jpg";